/**
 * Light/dark theme, persisted to localStorage and defaulting to the OS
 * preference. The theme is applied as `data-theme` on <html>; theme.css holds
 * the palette overrides.
 */
import { createSignal } from "solid-js";

export type Theme = "light" | "dark";

function initialTheme(): Theme {
  const stored = localStorage.getItem("fn-theme");
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia?.("(prefers-color-scheme: light)").matches ? "light" : "dark";
}

function apply(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  localStorage.setItem("fn-theme", theme);
}

const [theme, setThemeSignal] = createSignal<Theme>(initialTheme());
apply(theme());

export { theme };

export function setTheme(next: Theme): void {
  setThemeSignal(next);
  apply(next);
}

export function toggleTheme(): void {
  setTheme(theme() === "dark" ? "light" : "dark");
}
